/* eslint-disable */
import uiConfig from '@onereach/ui-config';
import config from '../env.json';

const localOverrides = {};

export default uiConfig(config, {}, localOverrides, false);

export const RASA_DOCS_URL = 'https://rasa.com/docs/rasa/api/http-api/';
export const AWS_COMPREHEND_DOCS_URL = 'https://docs.aws.amazon.com/comprehend/latest/dg/getting-started.html';
export const AWS_LEX_DOCS_URL = 'https://docs.aws.amazon.com/lex/latest/dg/getting-started.html';
export const DIALOG_FLOW_DOCS_URL = 'https://cloud.google.com/dialogflow/docs/reference/rest/v2-overview';
export const MS_LUIS_DOCS_URL = 'https://docs.microsoft.com/en-us/azure/cognitive-services/luis/luis-get-started-get-intent-from-rest';
export const MS_QNA_DOCS_URL = 'https://docs.microsoft.com/en-us/azure/cognitive-services/QnAMaker/quickstarts/get-answer-from-knowledge-base-using-url-tool';
export const SERVICE_NOW_DOCS_URL = 'https://docs.servicenow.com/bundle/paris-application-development/page/integrate/custom-web-services/task/t_CreateAScriptedRESTAPIResource.html';
export const VERSIONS_LIMIT_ON_PUBLISH = 100

// https://docs.microsoft.com/en-us/azure/cognitive-services/luis/luis-language-support
const LANGUAGES_WITH_PREBUILT_MODELS = [
    'zh-cn',
    'nl-nl',
    'en-us',
    'fr-fr',
    'de-de',
    'it-it',
    'ja-jp',
    'ko-kr',
    'pt-br',
    'es-es'
];
const LANGUAGE_WITH_PREBUILT_ENTITY = [
    'zn-cn',
    'en-us',
    'fr-fr',
    'de-de',
    'hi-in',
    'it-it',
    'ja-jp',
    'pt-br',
    'es-mx',
    'es-es',
    'tr-tr'
];
export const getSupportedFeatures = lang => ({
    prebuiltDomain: LANGUAGES_WITH_PREBUILT_MODELS.some(m => m === lang.toLowerCase()),
    prebuiltEntity: LANGUAGE_WITH_PREBUILT_ENTITY.some(m => m === lang.toLowerCase()),
});
